import type { RootState } from "@src/store/rootState";
import * as basicMod from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationInitialDraft";
import * as component from "@src/store/slices/experienceBuilder/component/selectors/getVariationInitialDraft";

export function getVariationInitialDraft(state: RootState) {
  return (
    basicMod.getVariationInitialDraft(state) ??
    component.getVariationInitialDraft(state)
  );
}
